var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11,
    r: 10,
    stroke: "#5F6369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 8.85742V16.5H9.4541V8.85742H11.5391ZM10.5 5.86328C10.8099 5.86328 11.0765 5.9362 11.2998 6.08203C11.5231 6.22331 11.6348 6.48991 11.6348 6.88184C11.6348 7.26921 11.5231 7.53809 11.2998 7.68848C11.0765 7.83431 10.8099 7.90723 10.5 7.90723C10.1855 7.90723 9.91667 7.83431 9.69336 7.68848C9.47461 7.53809 9.36523 7.26921 9.36523 6.88184C9.36523 6.48991 9.47461 6.22331 9.69336 6.08203C9.91667 5.9362 10.1855 5.86328 10.5 5.86328Z",
    fill: "#5F6369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.62751723359a5a4e19096d88a7b96f95.svg";
export { ForwardRef as ReactComponent };